import { executeStandardRequest } from '@musinsa/packages-http';
import { privateHttpClient } from '../httpClient';
import { salesRankingQueryKeys } from './queryKeys';
import type { GetSalesRankingLastUpdatedAtResponse } from './types';

export const getSalesRankingLastUpdatedAt = () =>
  executeStandardRequest(() =>
    privateHttpClient.get<GetSalesRankingLastUpdatedAtResponse>(
      salesRankingQueryKeys.getLastUpdatedAt,
    ),
  );
